module.exports = __webpack_public_path__ + "0b1d1c6fceade4b0b77ec8ab76f10c84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon.png
// module id = 1321
// module chunks = 1